export default __webpack_public_path__ + "images/d19ded05381e19e61a5638065dd65b07.png";